import {Box, ISelectProps, Select as NativeSelect} from 'native-base';
import React from 'react';
import {t} from 'react-native-tailwindcss';

export type SelectProps = ISelectProps & {};

export const Select = React.forwardRef<any, SelectProps>(({style, ...rest}, ref) => {
  return (
    <Box style={styles.wrapper}>
      <NativeSelect
        // @ts-ignore
        ref={ref!}
        style={[styles.input, style]}
        {...rest}
      />
    </Box>
  );
});

export const SelectItem = NativeSelect.Item;

const styles = {
  wrapper: [t.selfStretch],
  input: [t.h11, t.selfStretch, t.p3, t.textBase, t.textGray700]
};
